import { Component, Input, OnInit } from '@angular/core';
import { LocalLoadEvent } from '../../../shared/local-load-event.model';

@Component({
  selector: 'app-load-event-manual-item-added',
  templateUrl: './load-event-manual-item-added.component.html',
  styleUrls: ['./load-event-manual-item-added.component.scss']
})
export class LoadEventManualItemAddedComponent implements OnInit {

  @Input()
  event: LocalLoadEvent;

  constructor() {
  }

  ngOnInit() {
  }
}
